export default __webpack_public_path__ + "static/media/logo-small.c843dcf0.png";